import React, { useEffect, useState } from "react";
import styled from "styled-components";
import StyledSwitch from "src/components/StyledSwitch";
import { portalColors } from "src/components";
import { SocialMediaPlatform } from "./AccountLinking/utils/Enums";

/** Social Media Platform Icons */
import FacebookIcon from "src/img/noticeboard/facebook_colored.svg";
import LinkedInIcon from "src/img/noticeboard/linkedin_colored.svg";
import InstagramIcon from "src/img/noticeboard/instagram.svg";

const SocialItem = styled.div`
    width: ${p => p.isExpired ? "350px" : "315px"};
    height: 51px;
    border: 1px solid ${portalColors.border};
    border-radius: 12px;
    background: ${portalColors.surface};
    box-shadow: ${portalColors.shadow};
    margin-right: 54px;
    margin-bottom: 8px;
`;

const InnerBox = styled.div`
    width: initial;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 16px;
    min-width: 0;
    background: ${portalColors.surface};
    box-shadow: none;
    border: 1px solid ${portalColors.border};
    border-radius: 12px;
`;

const PageNameWrapper = styled.div`
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

const PageNameText = styled.span`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    text-align: left;
    font: normal normal bold 15px/18px Manrope;
    letter-spacing: 0px;
    color: ${portalColors.text};
    opacity: 1;
`;

const ProfilePicture = styled.div`
    width: 33px;
    height: 33px;
    border-radius: 50%;
    background: #D1D1D1 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-right: 12px;
`;

const TogglePageSwitch = (props) => (
    <StyledSwitch
        switchWidth={51}
        switchHeight={31}
        switchMarginTop="auto"
        switchMarginBottom="auto"
        checkedTranslateX={19}
        checkedThumbColor="#E8F5E9"
        checkedTrackColor="#4CAF50"
        checkedBorderColor="none"
        focusColor="#4CAF50"
        thumbSize={28}
        trackRadius={29 / 2}
        trackBackgroundColor="#C4C4C4"
        trackBorderColor="none"
        {...props}
    />
);

const ExpiredBadge = styled.div`
    width: 95px;
    height: 33px;
    border: 1px solid #FF3B3B;
    border-radius: 10px;
    color: #ff5757;
    background: var(--calendar-danger-soft, #fff7f7);
    display: flex;
    align-items: center;
    justify-content: center;
    font: normal normal bold 14px/18px Manrope;
`;

export const identifyPlatformLogo = (platformType) => {
    switch (platformType) {
        case SocialMediaPlatform.FACEBOOK:
            return FacebookIcon;
        case SocialMediaPlatform.INSTAGRAM:
            return InstagramIcon;
        case SocialMediaPlatform.LINKEDIN:
            return LinkedInIcon;
        default:
            console.error("Unsupported platform provided.");
            return null;
    }
};

function LinkedSocialPage(props) {
    const {
        pageName,
        pagePhoto,
        pageUuid,
        pagePlatformType,
        onToggle,
        checked,
        isPosted,
        isEditForm,
        scheduleDateInTheFuture,
        showToggleSwitch,
        isExpired
    } = props;
    if (isEditForm && !scheduleDateInTheFuture && !isPosted) {
        return null;
    }
    const [validLogo, setValidLogo] = useState(null);
    const logo = identifyPlatformLogo(pagePlatformType);
    const isInstagram = pagePlatformType === "Instagram";
    const disableButton = isExpired || (isInstagram && isPosted);

    useEffect(() => {
        const img = new Image();
        img.src = pagePhoto;

        img.onload = () => {
            setValidLogo(pagePhoto);
        };

        img.onerror = () => {
            setValidLogo(null);
        };
    }, [pagePhoto]);

    return (
        <SocialItem isExpired={isExpired}>
            <InnerBox>
                <img src={logo} alt={`${pagePlatformType} account`} height={34} width={34} style={{ marginRight: "6px", borderRadius: "50%" }} />
                {validLogo ? (
                    <img src={validLogo} alt={`${pageName} photo`} height={34} width={34} style={{ marginRight: "12px", borderRadius: "50%", opacity: validLogo ? 1.0 : 0.0 }} />
                ) : (
                    <ProfilePicture />
                )}
                <PageNameWrapper>
                    <PageNameText>{pageName}</PageNameText>
                </PageNameWrapper>
                {
                    isExpired &&
                    <ExpiredBadge>Expired</ExpiredBadge>
                }
                {
                    showToggleSwitch && !isExpired &&
                    <TogglePageSwitch onChange={() => onToggle(pageUuid)} checked={checked} disabled={disableButton} />
                }
            </InnerBox>
        </SocialItem>
    );
}

export default LinkedSocialPage;
